import { LocaleMessages } from '@/locales/locale-config.ts';

export const en: LocaleMessages = {
  'error.first_name': 'First name',
  'error.last_name': 'Last name',
  'error.email': 'Email',
  'error.phone': 'Phone',
  'error.employee_number': 'Employee number',
  'error.card_credit_limit': 'Card credit limit',
  'error.allpay_credit_limit': 'Allpay credit limit',
  'error.value.missing': 'value is missing',
  'error.value.invalid_format': 'has an invalid format',
  'error.value.duplicate': 'profiles with the same email address',
  'error.value.ignored_change': 'will not be updated',
  'error.required': 'Required',
  'error.invalid_email': 'Invalid email address',

  'error.import.invalid_email': 'Invalid email address',
  'error.import.address_or_stop_required':
    'Either address or bus stop is required',
  'error.import.school_address_required': 'Address is required',
  'error.import.nin_required': 'National identity number is required',
  'error.import.invalid_nin_format': 'Must be in YYYYMMDD-XXXX format',
  'error.import.invalid_zipcode': 'Invalid zip code',
  'error.import.delivery_address_required': 'Delivery address is required',
  'error.import.student_in_another_school':
    'Student is already enrolled at another organisation',
  'error.import.student_in_another_school_collection':
    'Student is already enrolled in {collection} at another organisation',
  'error.import.student_pending_inactivation':
    'Student is scheduled for inactivation at another organisation and has not been inactivated yet',
  'error.import.student_pending_inactivation_details':
    'Student is scheduled for inactivation in {collection} at another organisation from {date} and has not been inactivated yet',

  'status.inactive': 'Inactive',
  'status.submitted': 'Submitted',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',

  'period.status.upcoming': 'Upcoming',
  'period.status.active': 'Active',
  'period.status.past': 'Ended',

  'tab.information': 'Information',
  'tab.travellers': 'Travellers',
  'tab.admins': 'Administrators',
  'tab.advanced': 'Advanced',
  'tab.profile': 'Profile',
  'tab.tickets': 'Tickets',
  'tab.ticket_settings': 'Ticket settings',
  'tab.payers': 'Invoicing',
  'tab.students': 'Student Access',
  'tab.imports': 'Importer',
  'tab.periods': 'Periods',
  'tab.list': 'List',
  'tab.organizations': 'Organizations',
  'tab.applications': 'Applications',
  'tab.information_pages': 'Information pages',
  'tab.configuration': 'Configuration',
  'tab.transactions': 'Transactions',
  'tab.files': 'Files',
  'tab.invoicing': 'Invoicing',
  'tab.info': 'Info',
  'tab.travels': 'Travels',
  'tab.transportation': 'Transportation',
  'tab.child-and-youth': 'Child and Youth',

  // App metadata
  'app.title': 'AllTix',
  'app.description':
    'Public transportation tickets and travel management for {tenantName}',

  // Page metadata
  'page.dashboard.title': 'Dashboard',
  'page.dashboard.description':
    'Overview of your public transportation and tickets',
  newImport: 'New Import',

  'page.travellers.title': 'Travellers',
  'page.travellers.description': 'Manage travellers and their profiles',
  'page.search.title': 'Search',
  'page.search.description': 'Search for travellers',
  'page.traveller.title': '{travellerName}',
  'page.traveller.description': 'Traveller profile for {travellerName}',
  'page.traveller.details.title': 'Traveller Details',
  'page.traveller.details.description': 'View and manage traveller information',
  'page.traveller.changeBearerWarning':
    'When changing bearer, the preferred bearer is changed. All automatically issued tickets (e.g. school tickets) will automatically be placed on the new preferred bearer from now on.',

  'page.administrators.title': 'Administrators',
  'page.administrators.description':
    'Manage system administrators and permissions',
  'page.administrator.title': '{adminName}',
  'page.administrator.description': 'Administrator profile for {adminName}',
  'page.administrator.details.title': 'Administrator Details',
  'page.administrator.details.description':
    'View and manage administrator information',

  'page.departments.title': 'Departments',
  'page.departments.description':
    'Manage organizational departments and hierarchies',
  'page.department.title': '{departmentName}',
  'page.department.description': 'Department information for {departmentName}',
  'page.department.details.title': 'Department Details',
  'page.department.details.description':
    'View and manage department information',

  'page.tickets.title': 'Tickets',
  'page.tickets.description':
    'Purchase and manage public transportation tickets',

  'page.reports.title': 'Reports',
  'page.reports.description':
    'Analytics and reports on travel and transactions',
  'page.reports.transactions.title': 'Transactions',
  'page.reports.transactions.description':
    'Transaction reports and analysis of purchases and payments',
  'page.reports.files.title': 'Files',
  'page.reports.files.description':
    'Exported files and report files for download',

  'page.settings.title': 'Settings',
  'page.settings.description': 'System settings and configuration',

  'page.profile.title': 'My Profile',
  'page.profile.description': 'Manage your personal profile and settings',

  'page.login.title': 'Login',
  'page.login.description': 'Sign in to your public transportation account',

  'page.register.title': 'Register',
  'page.register.description': 'Create a new public transportation account',

  'page.privacy.title': 'Privacy Policy',
  'page.privacy.description':
    'Information about how we handle your personal data',

  'page.terms.title': 'Terms of Service',
  'page.terms.description':
    'Terms and conditions for using the public transportation service',

  // New page metadata keys
  'page.organizations.title': 'Organizations',
  'page.organizations.description': 'Manage organizations and their settings',
  'page.organizations.list.title': 'Organizations List',
  'page.organizations.list.description': 'View and manage all organizations',
  'page.organizations.applications.title': 'Organization Applications',
  'page.organizations.applications.description':
    'Review and approve organization applications',
  'page.periods.title': 'Periods',
  'page.periods.description':
    'Manage ticket periods for the student categories of organizations',
  'page.organization.details.title': 'Organization Details',
  'page.organization.details.description':
    'View and manage organization information',

  'page.students.title': 'Students',
  'page.students.description': 'Manage students and their transportation',
  'page.students.list.search.placeholder':
    'Search by name, national identity number, school, or card number',
  'page.students.list.search.placeholder.childAndYouth':
    'Search by name, national identity number, guardian email, or card number',
  'page.students.transportation.title': 'Student Transportation',
  'page.students.transportation.description':
    'Manage student travel arrangements',
  'page.students.transportation.list.title': 'Student Travel List',
  'page.students.transportation.list.description':
    'View all students with travel arrangements',
  'page.students.transportation.periods.title':
    'Student Transportation – Periods',
  'page.students.transportation.periods.description':
    'Manage ticket periods for student transportation',
  'page.students.travels.title': 'School Travels',
  'page.students.travels.description': 'Manage school travel arrangements',
  'page.students.travels.list.title': 'School Travels List',
  'page.students.travels.list.description':
    'View all students with school travel arrangements',
  'page.students.travels.periods.title': 'School Travels – Periods',
  'page.students.travels.periods.description':
    'Manage ticket periods for school travels',
  'page.students.child-and-youth.title': 'Child and Youth Tickets',
  'page.students.child-and-youth.description': 'Manage child and youth tickets',
  'page.students.child-and-youth.list.title': 'Child and Youth Tickets List',
  'page.students.child-and-youth.list.description':
    'View all students with child and youth tickets',
  'page.students.child-and-youth.periods.title':
    'Child and Youth Tickets – Periods',
  'page.students.child-and-youth.periods.description':
    'Manage ticket periods for child and youth tickets',
  'page.students.travels.info.title': 'School Travels – Info',
  'page.students.travels.info.description':
    'Information about how school travels works',
  'page.students.transportation.info.title': 'Student Transportation – Info',
  'page.students.transportation.info.description':
    'Information about how student transportation works',
  'page.students.child-and-youth.info.title': 'Child and Youth Tickets – Info',
  'page.students.child-and-youth.info.description':
    'Information about how child and youth tickets works',
  'page.students.manualEditWarning':
    'Manual editing of students in a student category will be overwritten during the next import if the same changes are not present in the import file.',

  'page.tenantSettings.title': 'Tenant Settings',
  'page.tenantSettings.description':
    'Manage tenant-wide settings and configuration',
  'page.tenantSettings.information.title': 'Information Settings',
  'page.tenantSettings.information.description':
    'Manage FAQ, terms, and support information',
  'page.tenantSettings.configuration.title': 'Configuration',
  'page.tenantSettings.configuration.description':
    'System configuration and technical settings',
  'page.tenantSettings.students.title': 'Student Settings',
  'page.tenantSettings.students.description': 'Settings for student programs',

  'page.user.title': 'User Settings',
  'page.user.description': 'Manage your personal settings and preferences',

  'page.buyTicket.title': 'Buy Ticket',
  'page.buyTicket.description': 'Purchase public transportation tickets',

  'page.faq.title': 'FAQ',
  'page.faq.description': 'Frequently asked questions and help',

  'page.support.title': 'Support',
  'page.support.description': 'Get help and support information',

  'page.systemAdministrators.title': 'System Administrators',
  'page.systemAdministrators.description':
    'Manage system administrators and their access',
  'page.systemAdministrator.details.title': 'System Administrator Details',
  'page.systemAdministrator.details.description':
    'View and manage system administrator information',

  'page.payers.title': 'Invoice Recipients',
  'page.payers.description':
    'Manage invoice recipients and billing information',

  'page.privacyPolicy.title': 'Privacy Policy',
  'page.privacyPolicy.description':
    'Information about data handling and privacy',

  'page.termsAndConditions.title': 'Terms and Conditions',
  'page.termsAndConditions.description':
    'Terms and conditions for service usage',

  'page.accessibilityStatement.title': 'Accessibility Statement',
  'page.accessibilityStatement.description':
    'Information about the accessibility of this website',

  'page.downtime.title': 'Scheduled maintenance',
  'page.downtime.description':
    'The portal is closed on Monday 26 October 2026 due to a planned system update',

  'page.operatingStatus.title': 'Operating Status',
  'page.operatingStatus.description': 'Current system and service status',

  'selectPortal.title': 'Select Portal',
  'selectPortal.description':
    'Select portal based on which region or city your organization is located in and has access to this service via.',
  'page.home.noTenants.title': 'No Portals Available',
  'page.home.noTenants.description':
    'No organization portals are currently available',

  'page.profiles.title': 'Select Profile',
  'page.profiles.description': 'Choose your organization profile',
  'page.profiles.noProfiles.title': 'No Profiles',
  'page.profiles.noProfiles.description':
    'No profiles are linked to your account',

  'page.menu.title': 'Menu',
  'page.menu.description': 'Main navigation menu',

  'page.selfService.login.title': 'Self Service',
  'page.selfService.login.description':
    'Manage your tickets and travel information',

  'page.offerings.title': 'Special Offers',
  'page.offerings.description': 'Special ticket offers and promotions',

  'page.travellers.import.title': 'Import Travellers',
  'page.travellers.import.description': 'Import traveller data from file',

  'page.imports.title': 'Imports',
  'page.imports.description': 'Previous imports',
  'page.imports.details.title': 'Import',
  'page.imports.details.description': 'Import details',

  'page.students.invoicing.title': 'Invoicing',
  'page.students.invoicing.description': 'Invoicing details for students',

  'import.state.added': 'Added',
  'import.state.updated': 'Updated',
  'import.state.restored': 'Restored',
  'import.state.removed': 'Removed',
  'import.state.skipped': 'Skipped',
  'import.state.failed': 'Failed',
  'import.state.addedPlural': 'Added',
  'import.state.updatedPlural': 'Updated',
  'import.state.updatedManuallyModified': 'Updated (manually modified)',
  'import.state.updatedManuallyModifiedPlural': 'Updated (manually modified)',
  'import.state.restoredPlural': 'Restored',
  'import.state.removedPlural': 'Removed',
  'import.state.skippedPlural': 'Skipped',
  'import.state.failedPlural': 'Failed',
  'import.state.confirmed': 'Confirmed',
  'import.state.confirmedPlural': 'Confirmed',

  'import.manuallyModified.title': 'Manually modified',
  'import.manuallyModified.description':
    'The data has been manually edited and may be overwritten during import if the same changes are not present in the import file.',

  'import.guardianAddressInfo.requiredForGuardian1':
    'Note that address and/or bus stop is required for Guardian 1. Guardian 2 is optional, but address and/or bus stop is required if Guardian 2 is to be used.',
  'import.guardianAddressInfo.usedForTravelSearch':
    'Address/bus stop for Guardian 1 and 2 is used to perform travel searches for where the ticket applies.',
  'import.guardianAddressInfo.busStopOptional':
    'A bus stop is only specified when the nearest bus stop from the address does not give a good result. The external Etis system only finds bus stops within 3 km of the address, so if the nearest bus stop is further away, a bus stop must be specified. When a bus stop is specified, the bus stop name in Etis is what applies.',
  'import.deliveryAddressInfo.cardDelivery':
    'The delivery address specifies where the travel card should be sent. Usually the registered home address or the school address.',

  'claim.state.scheduled.label': 'Scheduled',
  'claim.state.scheduled.description':
    'The system has scheduled the traveller for processing for the period.',
  'claim.state.card-ordered.label': 'Waiting for card',
  'claim.state.card-ordered.description':
    'Card order placed with provider. Once the card is created, the ticket order will be placed.',
  'claim.state.awaiting-card-transfer.label': 'Waiting for card transfer',
  'claim.state.awaiting-card-transfer.description':
    'A card transfer from the previous school is in progress. The ticket is purchased once the transfer is complete.',
  'claim.consecutiveFailures':
    '{count, plural, one {# failed attempt} other {# failed attempts}}',
  'claim.consecutiveFailures.description':
    'Number of times the system has tried to buy the ticket without succeeding.',
  'claim.state.card-order-failed.label': 'Card order failed',
  'claim.state.card-order-failed.description':
    "The provider's system did not allow the card order.",
  'claim.state.purchase-ordered.label': 'Ticket order placed',
  'claim.state.purchase-ordered.description':
    'Ticket order placed with provider, awaiting confirmation that the ticket has been purchased.',
  'claim.state.purchase-failed.label': 'Purchase failed',
  'claim.state.purchase-failed.description':
    "The provider's system did not allow the ticket order for this traveller.",
  'claim.state.unresolvable-relational-ticket.label': 'Ticket not found',
  'claim.state.unresolvable-relational-ticket.description':
    'Could not find a valid ticket for the provided addresses.',
  'claim.state.fulfilled.label': 'Ticket purchased',
  'claim.state.fulfilled.description':
    'The ticket has been purchased and distributed to the traveller.',
  'claim.state.unfulfillable.label': 'Unresolvable error',
  'claim.state.unfulfillable.description':
    'Something went wrong that cannot be resolved automatically and/or in the normal way. Contact support.',

  'formElement.noValue': 'No value',
  'formElement.requiredFieldHint': '(required field)',

  'ticketOffer.deliveryMethodQuestion': 'How would you like the ticket?',
  'ticketOffer.emailAddress': 'Email address',
  'ticketOffer.cardNumber': 'Card number',
  'ticketOffer.confirmationEmail': 'Confirmation email',
  'ticketOffer.confirmationEmailOptional': 'Confirmation email (optional)',
  'ticketOffer.accountNotFound':
    'No account was found. Check that the email is correct and that the account is registered in the app.',
  'ticketOffer.cardNotFound': 'Card not found',
  'ticketOffer.placeOrder': 'Order',
  'ticketOffer.termsDeclaration':
    'I certify that I have entered correct information above and understand that the offer may only be used by the selected recipient.',
  'ticketOffer.recipientNinLabel':
    "Recipient's personal identity number (12 digits)",
  'ticketOffer.error.ninFormat':
    'Personal identity number must be entered as YYYYMMDDXXXX or YYYYMMDD-XXXX',
  'ticketOffer.error.emailAppRequired':
    'A valid email is required for app delivery',
  'ticketOffer.error.cardNumberLength': 'Card number must be 16 characters',
  'ticketOffer.error.invalidEmail': 'Enter a valid email address',
  'ticketOffer.error.emailRequiredForDelivery':
    'Email is required for this delivery method',
  'ticketOffer.error.generic': 'Something went wrong',
  'ticketOffer.error.recipientTooOld':
    'The recipient must be 19 years old or younger',
  'ticketOffer.error.recipientBirthYear':
    'The recipient must be born between {minYear} and {maxYear}',
  'ticketOffer.loginBankId': 'Log in with BankID',

  'ticketOffer.granted.pickUpCard':
    'Go to customer service to pick up a new physical travel card',
  'ticketOffer.granted.availableSummer':
    'The offer is now available and can be used during the summer holiday.',
  'ticketOffer.granted.useInApp':
    'It is used in the app on a device that has the specified email linked.',
  'ticketOffer.granted.useOnCard': 'It is used on the selected card.',
  'ticketOffer.granted.title': 'Order completed',
  'ticketOffer.granted.dateLabel': 'Date',
  'ticketOffer.granted.orderIdLabel': 'Order ID',
  'ticketOffer.granted.ticketIdLabel': 'Ticket ID',
  'ticketOffer.granted.closePage': 'You can close this page now.',
  'ticketOffer.granted.orderAgain': 'Place another order',
} as const;
